<template>
  <div>
    <v-dialog v-model="dialog" max-width="1000px">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Add Missing Rate Plan</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-3">
          <v-row>
            <v-col
              md="6"
              v-for="(item, index) in getHeaders(ratePlan)"
              :key="index"
            >
              <v-select
                v-if="
                  item.value == 'usageType' ||
                    item.value == 'productType' ||
                    [
                      'payInitialComms',
                      'forcePayInitial',
                      'hasSpecialOverride',
                      'monitorDataUsage'
                    ].includes(item.value)
                "
                v-model="ratePlan[item.value]"
                :label="item.value"
                :items="
                  [
                    'payInitialComms',
                    'forcePayInitial',
                    'hasSpecialOverride',
                    'monitorDataUsage'
                  ].includes(item.value)
                    ? boolOptions
                    : item.value == 'usageType'
                    ? usageTypes
                    : productTypes
                "
                @change="
                  item.value == 'usageType' ? setProductTypes(ratePlan) : ''
                "
              ></v-select>
              <v-text-field
                v-else
                v-model="ratePlan[item.value]"
                :label="item.text"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">Save</v-btn>
          <v-btn color="primary" @click="init">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import RatePlan from "@/models/RatePlan";
export default {
  name: "AddRule",

  data() {
    return {
      ratePlan: {},
      addPlan: {},
      dialog: false,
      typeOptions: [
        {
          usageType: "DSL",
          productTypes: ["DSL"]
        },
        {
          usageType: "Fibre",
          productTypes: ["Fibre"]
        },
        {
          usageType: "NBN",
          productTypes: ["NBN"]
        },
        {
          usageType: "Vonex PBX",
          productTypes: ["PBX"]
        },
        {
          usageType: "Wholesale Service",
          productTypes: ["Wholesale"]
        },
        {
          usageType: "Mobile",
          productTypes: ["Mobile Broadband", "Mobile Voice"]
        },
        {
          usageType: "Voice",
          productTypes: ["Voice", "Rebill", "ULL"]
        },
        {
          usageType: "VoIP",
          productTypes: [
            "VOIP",
            "SIP",
            "Finance",
            "Hardware",
            "Corporate",
            "Other"
          ]
        }
      ],
      productTypes: []
    };
  },

  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),
    populate(val) {
      let vm = this;
      this.init();
      Object.assign(vm.ratePlan, new RatePlan(val));
      vm.ratePlan.id = 0;
      vm.ratePlan.ratePlanId = val.ratePlanID;
      vm.ratePlan.ratePlanPdf = val.ratePlanPDF;
      vm.ratePlan.qantasPlan = val.qantas;
      vm.setProductTypes(val);
      vm.dialog = true;
    },
    init() {
      let vm = this;
      vm.ratePlan = new RatePlan({});
      vm.dialog = false;
      vm.$emit("init");
    },
    save() {
      let vm = this;
      if (vm.dialog) {
        vm.ratePlan.id = parseInt(vm.ratePlan.id);
        vm.ratePlan.ratePlanId = parseInt(vm.ratePlan.ratePlanId);
        vm.ratePlan.qantasPoints = parseInt(vm.ratePlan.qantasPoints);
        vm.ratePlan.dataAllowance = parseInt(vm.ratePlan.dataAllowance);
        vm.ratePlan.contractMonths = parseInt(vm.ratePlan.contractMonths);
        vm.ratePlan.qantasBonusPoints = parseInt(vm.ratePlan.qantasBonusPoints);
        vm.ratePlan.qantasPoints = parseInt(vm.ratePlan.qantasPoints);
        vm.ratePlan.excessDataCharge = parseInt(vm.ratePlan.excessDataCharge);
        vm.ratePlan.monthlyRetail = parseFloat(vm.ratePlan.monthlyRetail);
        vm.ratePlan.monthlyProfitPercent = parseFloat(
          vm.ratePlan.monthlyProfitPercent
        );

        vm.ratePlan.handset = !!vm.ratePlan.handset;
        vm.ratePlan.monitorDataUsage = !!vm.ratePlan.monitorDataUsage;
        vm.ratePlan.payInitialComms = !!vm.ratePlan.payInitialComms;
        vm.ratePlan.hasSpecialOverride = !!vm.ratePlan.hasSpecialOverride;
        vm.ratePlan.qantasPlan = !!vm.ratePlan.qantasPlan;

        let query = {
          message: `Dealer Type added`,
          url: `Commissions/EditRatePlans/`,
          method: "post",
          body: [this.ratePlan]
        };
        this.CommissionsRequest(query)
          .then(() => {
            vm.init();
          })
          .catch(() => {});
      }
    },
    getProductTypes(item) {
      return this.typeOptions
        .filter(x => x.usageType === item)
        .map(x => x.productTypes)[0];
    },
    setProductTypes(item) {
      let usageTypes = [
        "DSL",
        "Fibre",
        "NBN",
        "Vonex PBX",
        "Wholesale Service"
      ];
      this.productTypes = this.typeOptions
        .filter(x => x.usageType == item.usageType)
        .map(x => x.productTypes)[0];

      if (usageTypes.includes(item.usageType))
        this.ratePlan.productType = this.getProductTypes(item.usageType)[0];
    }
  },
  computed: {
    usageTypes() {
      return this.typeOptions.map(x => {
        return x.usageType;
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
